module.exports = __webpack_public_path__ + "media/images/img_male_2-ad575f9ea42b6ad55957cd7c7c5f300b.png";